<template>
  <div class="sbks-steps">
    <div
      v-for="(item, indexs) in values"
      :key="indexs"
      :class="'sbks-steps-item ' + status(indexs)"
    >
      <div class="sbks-steps-item-icon">
        <span class="sbks-steps-item-content"
          ><i :class="'iconfont ' + item.icon" style="fontSize:26px"></i
        ></span>
      </div>
      <div class="sbks-steps-item-names">{{ item.name }}</div>
    </div>
    <!-- <div v-for="(t, index) in values" :key="index">
        <div>
          <div>{{ t }}</div>
        </div>
      </div> -->
  </div>
</template>
<script>
export default {
  props: {
    current: {
      type: Number,
      default: 0,
    },
    values: {
      type: Array,
      default: [],
    },
    imgs: {
      type: Array,
      default: [],
    },
  },
  computed: {
    status() {
      return function(index) {
        const _crt = parseInt(this.current) ? parseInt(this.current) : 0
        const _length = this.values.length
        const _current = _crt < 0 ? 0 : _crt > _length - 1 ? _length - 1 : _crt
        return index > _current
          ? 'wait'
          : index === _current
          ? 'active'
          : 'finish'
      }
    },
  },
}
</script>
<style lang="less" scoped>
.sbks-steps {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;

  box-sizing: border-box;
  &-item {
    list-style-type: none;
    font-size: 14px;
    float: left;
    position: relative;
    width: 33.333%;
    text-align: center;

    &-names {
      margin-top: 10px;
      color: rgba(120, 140, 162, 1);
    }
    // &:last-child {
    //   flex: none;
    // }
    &:after {
      content: '';
      width: calc(100% - 60px);
      height: 1px;
      background: #eaedef;
      position: absolute;
      left: calc((-100% + 60px) / 2);
      top: 30px;
      display: block;
    }
    &:first-child:after {
      content: none;
    }
    &-icon {
      color: #ffffff;
      width: 60px;
      height: 60px;
      margin-right: 8px;
      font-size: 26px;
      text-align: center;
      display: inline-block;
      border-radius: 50%;
      line-height: 60px;
      position: relative;
      text-align: center;
    }
    &-content {
      font-size: 14px;
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      text-align: center;
    }
    &.active:after,
    &.finish:after {
      background: rgba(97, 127, 235, 1);
    }
    &.active .sbks-steps-item-content {
      border-radius: 50%;
      background: rgba(97, 127, 235, 1);
    }

    &.wait .sbks-steps-item-content {
      border-radius: 50%;
      background: #eff3fa;
      color: #c4d6e9;
    }
    &.finish .sbks-steps-item-content {
      border-radius: 50%;
      background: rgba(97, 127, 235, 1);
    }
  }
}
</style>
